import type { Option } from '@branchjs/neo-components';
import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_QR_CODE_LINK_TAGS = 'UPDATE_QR_CODE_LINK_TAGS' as const;

export const updateQrCodeLinkTags = (tags: Option[]) => ({
  data: { tags },
  type: UPDATE_QR_CODE_LINK_TAGS,
});

export type UpdateQrCodeLinkTagsResponseAction = DataAction<typeof UPDATE_QR_CODE_LINK_TAGS, { tags: Option[] }>;
